import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { combineReducers } from 'redux'
import { load, save } from 'redux-localstorage-simple'
import accountReducer from 'store/account/reducer'
import appReducer from 'store/app/reducer'
import assetsReducer from 'store/assets/reducer'
import convertReducer from 'store/convert/reducer'
import depositReducer, {
  initialState as depositInitialState,
} from 'store/deposit/reducer'
import historyReducer from 'store/history/reducer'
import linkReducer from 'store/link/reducer'
import loayltyReducer from 'store/loaylty/reducer'
import marketReducer from 'store/market/reducer'
import orderReducer from 'store/order/reducer'
import orderbookReducer from 'store/orderbook/reducer'
import perpReducer, {
  initialState as perpInitialState,
} from 'store/perp/reducer'
import settingReducer, {
  initialState as settingsInitialState,
} from 'store/settings/reducer'
import spotReducer, {
  initialState as spotInitialState,
} from 'store/spot/reducer'
import withdrawReducer from 'store/withdraw/reducer'
import wsReducer from 'store/ws/reducer'
import web3Reducer from 'store/web3/reducer'
import brokerReducer from 'store/broker/reducer'
import { connectSlice } from './connect/reducer'
import earnsReducer from 'store/earns/reducer'

const rootReducer = combineReducers({
  account: accountReducer,
  app: appReducer,
  deposit: depositReducer,
  history: historyReducer,
  link: linkReducer,
  connect: connectSlice.reducer,
  web3: web3Reducer,
  market: marketReducer,
  order: orderReducer,
  orderbook: orderbookReducer,
  perp: perpReducer,
  settings: settingReducer,
  spot: spotReducer,
  withdraw: withdrawReducer,
  broker: brokerReducer,
  loaylty: loayltyReducer,
  convert: convertReducer,
  assets: assetsReducer,
  ws: wsReducer,
  earns: earnsReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch

const persistedStates: string[] = [
  'settings',
  'connect',
  'deposit.pendingTxs',
  'spot.orderMode',
  'perp.orderMode',
]
const namespace: string = 'zkex_v3_1'
const namespaceSeparator: string = '::'

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        ignoredPaths: ['link.signer'],
        ignoredActionPaths: [
          'payload.signer',
          'meta.arg.provider',
          'meta.arg.signer',
        ],
      },
    }).concat(
      save({
        states: persistedStates,
        namespace,
        namespaceSeparator,
        debounce: 200,
      }),
    ),
  preloadedState: (function () {
    const storedData: any = load({
      states: persistedStates,
      namespace,
      namespaceSeparator,
      disableWarnings: process.env.NODE_ENV === 'test',
    })

    storedData.deposit = {
      ...depositInitialState,
      ...storedData.deposit,
    }

    storedData.spot = {
      ...spotInitialState,
      ...storedData.spot,
    }

    storedData.perp = {
      ...perpInitialState,
      ...storedData.perp,
    }

    storedData.settings = {
      ...settingsInitialState,
      ...storedData.settings,
    }
    return storedData
  })(),
})
